/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackagingUnitIdsByEanRequest } from '../../models/packaging-unit-ids-by-ean-request';
import { PackagingUnitIdsByEanResponse } from '../../models/packaging-unit-ids-by-ean-response';

export interface GetIdsByEanCodes$Params {
      body: PackagingUnitIdsByEanRequest
}

export function getIdsByEanCodes(http: HttpClient, rootUrl: string, params: GetIdsByEanCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingUnitIdsByEanResponse>> {
  const rb = new RequestBuilder(rootUrl, getIdsByEanCodes.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingUnitIdsByEanResponse>;
    })
  );
}

getIdsByEanCodes.PATH = '/products/ids-by-ean';
